import { css } from 'styled-system/css';

export const confirmBetStyle = {
	root: css({
		base: {},
		_mars: {
			color: 'black.1',
			boxShadowColor: 'betslip.shadow',
			smOnly: {
				width: '100%',
				transform: 'none',
				left: 0,
			},
			md: {
				boxShadow: '0px 0px 24px {colors.betslip.shadow}',
			},
			'& .icon--checkbox-active, & .icon--ticket-success-line': {
				color: 'status.positive',
			},

			'& .icon--ticket-exclamation, & .icon--ticket-error-line': {
				color: 'status.negative',
			},
		},
	}),
	confirmBetheader: css({
		base: {
			'--modal-header-bg': {
				base: 'var(--s800)',
				_dark: 'var(--other-lv4)',
			},
			display: 'flex',
			height: '42px',
			p: '3px',
			bgColor: 'var(--modal-header-bg)',
			alignContent: 'center',
			fontSize: '16px',
			fontWeight: '700',
			borderTopRadius: 'inherit',
			_ltr: {
				pr: '6px',
			},
			_rtl: {
				pl: '6px',
			},
			md: {
				p: '9px',
				_ltr: {
					pl: '12px',
				},
				_rtl: {
					pr: '12px',
				},
			},
			'& .icon--arrow-left': {
				width: '20px',
				height: '20px',
			},
		},
		_mars: {
			bgColor: 'var(--other-lv2)',
			color: 'black.1',
			'& .btn--text': {
				color: 'white',
				bgColor: 'betslip.parlayHeaderButtonBg',
			}
		},
		_galaxy: {
			bgColor: 'var(--background-component-header-main)',
			color: 'var(--text-utility-constant-white-100)',
		}
	}),
	floatConfirmBetheader: css({
		base: {
			'--m-fcbh-bg-color': { base: 'colors.primary.500', _dark: 'var(--s700)' },
			h: '48px',
		},
		_mars: {
			pl: '9px',
			alignItems: 'center',
			fontSize: '14px!',
			bgColor: 'var(--m-fcbh-bg-color)',
			color: 'white',
		},
	}),
	confirmBetModal: css({
		base: {
			'--m-cbm-bg-color': { base: 'var(--s600)', _dark: 'var(--s800)' },
			zIndex: 'var(--confirm-bet-zindex)',
			mb: '39px',
			borderRadius: 'var(--border-radius-lg)',
			'&[data-expand="false"]': {
				display: 'none',
			},
			'& .bet-slip__container > .scrollbar': {
				flex: 1,
			},
			smOnly: {
				width: '100%',
				transform: 'none',
				_ltr: {
					left: 0,
				},
				_rtl: {
					right: 0,
				},
			},
			md: {
				width: '600px',
				maxH: 'calc(100vh - 48px - 140px)', // 參考 modal.scss
				_ltr: {
					transform: 'translateX(-50%)',
				},
				_rtl: {
					transform: 'translateX(50%)',
				},
			},
			_mdBelow: {
				top: 0,
				maxH: '100vh',
				overscrollBehavior: 'contain',
				rounded: 0,
				mb: '0',
			},
		},
		_mars: {
			bgColor: 'var(--m-cbm-bg-color)',
		}
	}),
	closeButton: css({
		_mars: {
			color: 'black.3',
		},
		_galaxy: {
			color: 'var(--text-utility-constant-white-54)',
		}
	}),
	floatCloseButton: css({
		base: {
			'--m-close-color': { base: 'white', _dark: 'colors.whiteOpacity.54' }
		},
		_mars: {
			color: 'var(--m-close-color)'
		},
	}),
	headerIcon: css({
		_mars: {
			color: 'brand.500_light',
		}
	}),
	headerBadge: css({
		base: {
			display: 'flex',
			justifyContent: 'center',
			alignItems: 'center',
			minWidth: '15px',
			height: '15px',
			color: 'var(--lv2-100)',
			bgColor: 'var(--p500)',
			rounded: '15px',
			fontWeight: '400',
			fontSize: '12px',
			px: '3px',
			_ltr: {
				ml: '6px',
			},
			_rtl: {
				mr: '6px',
			}
		},
		_mars: {
			color: 'white',
		},
		_galaxy: {
			color: 'var(--text-primary-500-white-100)',
			bgColor: 'var(--background-utility-constant-white-primary-500)',
		}
	}),
	floatHeaderBadge: css({
		_mars: {
			bgColor: '#FF3333',
		}
	}),
	ticktetheader: css({
		_mars: {
			bgColor: 'var(--s500)',
		},
	}),
	floatTicketHeader: css({
		'--m-fth-bg-color': { base: 'var(--s400)', _dark: 'var(--s400)' },
		_mars: {
			bgColor: 'var(--m-fth-bg-color)'
		}
	}),
	headerRunning: css({
		_mars: {
			bgColor: 'status.positive_bg!',
		},
	}),
	headerReject: css({
		_mars: {
			bgColor: 'status.negative_bg!',
		},
	}),
	confirmBetScrollbar: css({
		base: {
			display: 'contents',
		},
	}),
	confirmBetParlayScrollbar: css({
		base: {
			p: '6px',
			overflowY: 'auto',
			overflowX: 'hidden',
			overscrollBehavior: 'contain',
			display: 'block!',
			md: {
				p: '12px',
				_scrollbar: {
					width: '8px',
				},
				_scrollbarThumb: {
					rounded: '6px',
				},
				_scrollbarTrack: {
				},
			},
		},
		_mars: {
			p: '6px',
			overflowY: 'auto',
			overflowX: 'hidden',
			overscrollBehavior: 'contain',
			display: 'block!',
			md: {
				p: '12px',
				_scrollbar: {
					width: '8px',
					bgColor: 'var(--s600)',
				},
				_scrollbarThumb: {
					bgColor: 'var(--s800)',
					border: '1px solid var(--s600)',
					rounded: '6px',
				},
				_scrollbarTrack: {
					bgColor: 'var(--s600)',
				},
			},
		},
		_galaxy: {
			md: {
				p: '0',
			},
		},
	}),
	confirmBetWrap: css({
		base: {
			display: 'contents',
		},
	}),
	// isParlayMode
	confirmParlayBetWrap: css({
		base: {
			display: 'block',
			rounded: '6px',
			overflow: 'hidden',
		},
		_mars: {
			bgColor: 'var(--other-lv2)',
		},
		_galaxy: {
			rounded: '0',
		},
	}),
	backdrop: css({
		base: {
			md: {
				display: 'block',
			}
		}
	}),
	ticket: css({
		_mars: {
			borderColor: 'black.5',
		}
	}),
	bettingInfo: css({
		_mars: {
			borderColor: 'black.5',
		}
	}),
	info: css({
		_mars: {
			display: 'none',
		},
	}),
	ticketId: css({
		_mars: {
			color: 'black.2',
		},
	}),
	label: css({
		_mars: {
			color: 'black.1',
			fontSize: '12px',
		},
	}),
	amount: css({
		_mars: {
			color: 'secondary.500',
		},
	}),
	amountSize: css({
		_mars: {
			fontSize: '20px',
			fontWeight: '700',
			lineHeight: '24px',
		},
	}),
	button: css({
		_mars: {
			position: 'relative',
			color: 'whiteOpacity.100',
			bgColor: 'brand.500',
		},
	}),
	badge: css({
		_mars: {
			position: 'absolute',
			right: '-6px',
			top: '-6px',
			color: 'whiteOpacity.100',
			bgColor: 'secondary.500',
			width: '15px',
			height: '15px',
			rounded: '10px',
		},
	}),
	bottomInfo: css({
		base: {
			display: 'none',
		},
		_mars: {
			width: '100%',
			p: '6px 9px',
			display: 'flex',
			flexWrap: 'wrap',
			alignItems: 'center',
			columnGap: '12px',
			justifyContent: 'flex-end',
			bgColor: 'var(--s500)',
		},
	}),
	hide: css({
		base: {
			display: 'none',
		}
	}),
}